import { useCallback } from 'react';

import { ProfileModel } from '@pukka/api';
import { Dropdown, DropdownValue } from '@pukka/ui-components';
import { FaStoreAlt } from 'react-icons/fa';
import { twJoin } from 'tailwind-merge';

interface OutletSelectorProps {
  readonly outlets: ProfileModel.Outlet[];
  readonly onOutletChange: (outlet: ProfileModel.Outlet) => void;
  readonly selectedOutlet: DropdownValue;
  readonly disabled?: boolean;
}

function OutletSelector({ outlets, onOutletChange, selectedOutlet, disabled }: OutletSelectorProps) {
  const onChange = useCallback(
    (value: typeof selectedOutlet) => {
      onOutletChange(value.meta as ProfileModel.Outlet);
    },
    [onOutletChange],
  );

  return (
    <Dropdown
      value={selectedOutlet}
      onChange={onChange}
      icon={<FaStoreAlt className={twJoin('mr-2 w-4 ', disabled ? 'text-white' : 'text-neutral-400 ')} />}
      disabled={disabled}
      optionsClassName="max-h-[720px]"
    >
      {outlets.map((outlet) => (
        <Dropdown.Option
          key={`${outlet.id}|${outlet.name}`}
          value={{
            key: outlet.id,
            value: outlet.name || '',
            meta: outlet,
          }}
        >
          {outlet.name}
        </Dropdown.Option>
      ))}
    </Dropdown>
  );
}

export { OutletSelector };
